import { ACTIONS } from "./actions";



const initialState = {
  reports: [],
  reportTemplates: null,
  reportTemplateLoading: true,
  reports_loading: false
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIONS.SET_ALL_REPORTS:
      return {
        ...state,
        reports: payload,
        reportTemplateLoading: false
      };

    case ACTIONS.SET_ALL_REPORT_TEMPLATES:
      return {
        ...state,
        reportTemplates: payload,
        reportTemplateLoading: false
      };
    case ACTIONS.SET_REPORTS_LOADING:
      return {
        ...state,
        reports_loading: payload,
        reportTemplateLoading: false
      };
    case ACTIONS.SET_REPORTS_TEMPLATES_LOADING:
      return {
        ...state,
        reports_loading: false,
        reportTemplateLoading: payload
      };
    case ACTIONS.SET_DELETE_REPORT: {
      return {
        ...state,
        reports: state.reports.filter(
          report => report.report_uuid !== payload.uuid
        ),
        reportTemplateLoading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
